import React from 'react';
import Plot from 'react-plotly.js';

function ChartComponent({ dateList, profitList }) {
  const positiveColor = '#21862A';
  const negativeColor = '#EA1414';

  const segments = [];
  for (let i = 0; i < dateList.length - 1; i++) {
    const currentDate = new Date(dateList[i]);
    const nextDate = new Date(dateList[i + 1]);
    const profitStart = profitList[i];
    const profitEnd = profitList[i + 1];

    if ((profitStart >= 0 && profitEnd < 0) || (profitStart < 0 && profitEnd >= 0)) {
      // Calculate zero crossing point
      const zeroCrossingTime = currentDate.getTime() + ((0 - profitStart) * (nextDate.getTime() - currentDate.getTime())) / (profitEnd - profitStart);
      const zeroCrossingDate = new Date(zeroCrossingTime);

      // Split into two segments at the zero crossing
      segments.push({
        x: [currentDate, zeroCrossingDate],
        y: [profitStart, 0],
        type: 'scatter',
        mode: 'lines',
        line: { color: profitStart >= 0 ? positiveColor : negativeColor, width: 2 },
        showlegend: false
      });

      segments.push({
        x: [zeroCrossingDate, nextDate],
        y: [0, profitEnd],
        type: 'scatter',
        mode: 'lines',
        line: { color: profitEnd >= 0 ? positiveColor : negativeColor, width: 2 },
        showlegend: false
      });

      // Add markers for the actual data points, excluding zero crossing
      segments.push({
        x: [currentDate],
        y: [profitStart],
        type: 'scatter',
        mode: 'markers',
        marker: { size: 8, color: profitStart >= 0 ? positiveColor : negativeColor },
        showlegend: false
      });

      segments.push({
        x: [nextDate],
        y: [profitEnd],
        type: 'scatter',
        mode: 'markers',
        marker: { size: 8, color: profitEnd >= 0 ? positiveColor : negativeColor },
        showlegend: false
      });
    } else {
      // Create a single segment with consistent color and markers
      segments.push({
        x: [currentDate, nextDate],
        y: [profitStart, profitEnd],
        type: 'scatter',
        mode: 'lines+markers',
        marker: { size: 8, color: profitStart >= 0 ? positiveColor : negativeColor },
        line: { color: profitStart >= 0 ? positiveColor : negativeColor, width: 2 },
        showlegend: false
      });
    }
  }

  return (
    <>
      <Plot
        data={segments}
        layout={{
          xaxis: { title: 'Date' },
          yaxis: { title: 'Profit (%)' },
          shapes: [
            {
              type: 'rect',
              xref: 'paper',
              yref: 'y',
              x0: 0,
              x1: 1,
              y0: 0,
              y1: Math.max(...profitList),
              fillcolor: 'rgba(34, 139, 34, 0.1)',
              line: { width: 0 }
            },
            {
              type: 'rect',
              xref: 'paper',
              yref: 'y',
              x0: 0,
              x1: 1,
              y0: Math.min(...profitList),
              y1: 0,
              fillcolor: 'rgba(255, 0, 0, 0.1)',
              line: { width: 0 }
            }
          ],
          showlegend: false,
          responsive: true
        }}
      />
    </>
  );
}

export default ChartComponent;
